import { render, staticRenderFns } from "./AssigneeDrawer.vue?vue&type=template&id=2c9b2548&scoped=true"
import script from "./AssigneeDrawer.vue?vue&type=script&lang=js"
export * from "./AssigneeDrawer.vue?vue&type=script&lang=js"
import style0 from "./AssigneeDrawer.vue?vue&type=style&index=0&id=2c9b2548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9b2548",
  null
  
)

export default component.exports